import React from 'react';
import {
  QuoteAuthorName,
  QuoteAuthorTitle,
  QuoteAvatarContainer,
  QuoteAvatarImage,
  QuoteAvatarLine,
  QuoteText,
  StyledQuoteSection,
} from './quoteSection.styles';
import { image } from '../../../../helpers/image';

interface QuoteSectionProps {
  quote: string;
  author: string;
  title: string;
  authorImage: string;
}
const QuoteSection: React.FC<QuoteSectionProps> = ({ quote, author, title, authorImage }) => {
  return (
    <StyledQuoteSection>
      <QuoteAvatarContainer>
        <QuoteAvatarLine />
        <QuoteAvatarImage src={image(`devportal/quote-authors/${authorImage}`)} alt="Quote author" />
        <QuoteAvatarLine />
      </QuoteAvatarContainer>
      <QuoteAuthorName>{author}</QuoteAuthorName>
      <QuoteAuthorTitle>{title}</QuoteAuthorTitle>
      <QuoteText>{`“${quote}”`}</QuoteText>
    </StyledQuoteSection>
  );
};
export default QuoteSection;
